import { createAsyncThunk } from '@reduxjs/toolkit';
import { RecyclersAPI } from './RecyclerApi';

export const fetchAllRecyclers = createAsyncThunk('recyclers/fetchAllRecyclers', async () => {
  const response = await RecyclersAPI.fetchAllRecyclers();
  return response.data;
});
